module.exports = __webpack_public_path__ + "media/images/hd@2x-88f59f2ad468ff0d35b5b36686bed9f5.png";